import i18n from 'i18nextInstance';
import { theme } from 'styled';
const {
    dangerColor,
    successColor,
    warningColor
} = theme;

export const HEADERS = [{
    key: 'date',
    label: i18n.t('Creado'),
    orderKey: 'created_at'
}, {
    flex: 2,
    key: 'patientDisplay',
    label: i18n.t('Paciente'),
    orderKey: 'patient_name'
}, {
    key: 'range',
    label: i18n.t('Rango'),
    orderKey: 'range'
}, {
    key: 'processed_range',
    label: i18n.t('Rango procesado'),
    orderKey: 'doctor_range'
}, {
    format: row => {
        const { status } = row;
        switch (status) {
        case ('accepted'): return {
            color: successColor
        };
        case ('rejected'): return {
            color: dangerColor
        };
        case ('reviewed'): return {
            color: warningColor
        };
        default: return {
            fontWeight: 'bold'
        };
        }
    },
    key: 'parsedStatus',
    label: i18n.t('Estado')
}, {
    key: 'absence_report_reason',
    label: i18n.t('Motivo'),
    orderKey: 'absence_report_reason'
}, {
    key: 'workplace',
    label: i18n.t('Lugar de trabajo'),
    orderKey: 'workplace'
}];

export const downloadHeaders = [...HEADERS, {
    key: 'comment',
    label: i18n.t('Comentarios')
}, {
    key: 'status_comment',
    label: i18n.t('Comentarios del profesional')

}, {
    key: 'parsedFamiliarRelation',
    label: i18n.t('Relación familiar')
}];
